import { FontSize } from "../../utils/Fonts";
import Text from "../Text/Text";
import { ButtonWrapper, Container } from "./styled";
import { ButtonProps } from "./types";

export default function Button(buttonProps: ButtonProps) {
  const { text, isLoading, disabled, handleClick } = buttonProps;

  const handleClickButton = () => {
    if (disabled) return;

    if (!handleClick) return;

    handleClick();
  };
  return (
    <Container>
      <ButtonWrapper
        $isLoading={isLoading}
        onClick={handleClickButton}
        type="button"
      >
        <Text
          value={text ?? "Texto del botton"}
          fontSize={FontSize.TEXT_SM}
          lineCount={1}
          fontColor="#FFF"
        />
      </ButtonWrapper>
    </Container>
  );
}
